import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/calendar-project-preview-calendar';

Component('tr-calendar-project-preview-calendar', {
  properties: {
    firstTodoName: String,
    secondTodoName: String,
    thirdTodoName: String,
    firstListName: String,
    secondListName: String,
    thirdListName: String,
    animojiAvatars: Array,
  },

  mixins: [eventListenerMixin],

  connected() {
    this.initTodos();
  },

  disconnected() {
    this.stopListening();
  },

  initTodos() {
    ['firstTodos', 'secondTodos', 'thirdTodos'].forEach((key, index) => {
      const todoId = index + 1;
      this[key] = this.querySelectorAll(`.calendar-project-preview-calendar-todo[data-todo-id="${todoId}"]`);
    });
  },

  updateTodoName(todo, name) {
    const targetTodoName = `${todo}Name`;
    const targetTodos = `${todo}s`;
    const assignee = this.animojiAvatars[this.todoSequence(todo)];
    if (name && name.length > 0) {
      // NOTE: 日历视图里，同一个 todo 有很多个 clip element
      this[targetTodos].forEach((todoElement) => {
        this.renderTodoHTML(todoElement, name, assignee);
      });
    } else {
      this[targetTodos].forEach((todoElement) => {
        this.emptyTodoHTML(todoElement);
      });
    }
    this[targetTodoName] = name;
  },

  renderTodoHTML(todo, todoName, assignee) {
    const todoElem = todo;
    const blockName = 'calendar-project-preview-calendar';
    todoElem.innerHTML = `
    <img src="https://towerfiles.oss-cn-hangzhou.aliyuncs.com/animoji/${assignee}.png" alt="${assignee}" class="${blockName}-todo-assignee">
    <div class="${blockName}-todo-name">${todoName}</div>
    `.trim();
  },


  emptyTodoHTML(todo) {
    const todoElem = todo;
    todoElem.innerHTML = '';
  },

  todoSequence(todo) {
    return {
      firstTodo: 0,
      secondTodo: 1,
      thirdTodo: 2,
    }[todo];
  },
});
